import { useTranslation } from "next-i18next";
import { FunctionComponent } from "react";

import { Card } from "@baseComponents/Card";
import Flutter from "@public/portfolio_agile/just/flutter.svg";
import MySql from "@public/portfolio_agile/just/mysql.svg";
import Python from "@public/portfolio_agile/just/python.svg";

import { CaseStudyShortDesc } from "../project/CaseStudyShortDesc";

export const JustDescription: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <CaseStudyShortDesc desc={t("just app short desc")}>
      <Card
        type="technology"
        title="Flutter"
        icon={<Flutter alt="Flutter Logo" />}
      >
        {t("just.flutter")}
      </Card>

      <Card
        type="technology"
        title="Python"
        icon={<Python alt="Python Logo" />}
      >
        {t("just.python")}
      </Card>

      <Card type="technology" title="MySQL" icon={<MySql alt="MySql Logo" />}>
        {t("just.my_sql")}
      </Card>
    </CaseStudyShortDesc>
  );
};
